export default __webpack_public_path__ + "static/media/formGoPhoto.f2a24348.svg";